<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div class="mt-6">
        <v-card elevation="6">
          <div class="pa-3">
            <div class="pa-4">
              <span style="font-size: 24px">การแก้ไขข้อมูลรอบนับสต๊อก</span>
            </div>
            <!-- Mobile -->
            <div class="ml-6 d_mobile">
              <div class="ml-1">รอบนับครั้งที่</div>
              <div class="ma-2">{{ stock_list.stock_name }}</div>
            </div>
            <div class="ml-6 mr-6 d_mobile">
              <div class="ml-1">วันที่นับสต๊อก</div>
              <div class="ma-2">{{ date_show }}</div>
            </div>
            <div class="d_mobile">
              <div class="ml-6">
                <div class="ml-1 mb-2">ผู้นับสต๊อก</div>
              </div>
              <div class="grid_checkbox mb-6" style="margin-left: 15%">
                <div class="d-flex align-center" v-for="(count, index) in emp_lists" :key="index">
                  <v-checkbox class="ma-0" color="#86bc3a" hide-details="auto" v-model="count.select"></v-checkbox>
                  <div>
                    {{ count.username }}
                  </div>
                </div>
              </div>
            </div>
<!--            <div class="d_mobile mb-6">-->
<!--              <div class="ml-6">-->
<!--                <div class="ml-1">นำเข้าไฟล์ CSV</div>-->
<!--              </div>-->
<!--              <div class="ml-6 mr-6">-->
<!--                <v-file-input color="#86bc3a" ref="file" class="input_width" label="เลือกไฟล์" prepend-icon="mdi-microsoft-excel"  hide-details="auto" accept=".csv,.xls,.xlsx" disabled></v-file-input>-->
<!--              </div>-->
<!--            </div>-->
            <div class="d_mobile">
              <div class="ml-6">
                <div class="ml-1">หมายเหตุ</div>
              </div>
              <div class="ml-6 mr-6 mt-2">
                <v-text-field color="#86bc3a" class="input_width" label="หมายเหตุ" hide-details="auto"  outlined></v-text-field>
              </div>
            </div>
            <div class="ma-6 d_mobile">
              <div class="ml-1">ผู้สร้างรอบนับ</div>
              <div class="ma-2">{{ $store.state.userDetail.name }}</div>
            </div>
            <!-- PC & Tablet -->
            <div class="mb-6 grid_row">
              <div class="ma-6">
                <div class="ml-1">รอบนับครั้งที่</div>
              </div>
              <div class="mt-6 mr-1">
                <div>{{ stock_list.stock_name }}</div>
              </div>
            </div>
            <div class="grid_row">
              <div class="ma-6">
                <div class="ml-1 mt-n6">วันที่นับสต๊อก </div>
              </div>
              <div>{{ date_show }}</div>
            </div>
            <div class="mb-6 grid_header">
              <div class="ma-6">
                <div class="ml-1">ผู้นับสต๊อก</div>
              </div>
              <div class="grid_checkbox">
                <div class="d-flex align-center" v-for="(count, index) in emp_lists" :key="index">
                  <v-checkbox class="ma-0" color="#86bc3a" hide-details="auto" v-model="count.select"></v-checkbox>
                  <div>
                    {{ count.username }}
                  </div>
                </div>
              </div>
            </div>
<!--            <div class="mb-6 grid_row">-->
<!--              <div class="ma-6">-->
<!--                <div class="ml-1 mt-n6">นำเข้าไฟล์ CSV</div>-->
<!--              </div>-->
<!--              <div class="mr-1">-->
<!--                ยังไม่มี-->
<!--              </div>-->
<!--            </div>-->
            <div class="mb-6 grid_row">
              <div class="ma-6 mt-n1">
                <div class="ml-1">หมายเหตุ</div>
              </div>
              <div class="mt-n2 mr-1">
                <v-text-field color="#86bc3a" class="input_width" label="หมายเหตุ" hide-details="auto" v-model="stock_list.stock_note" outlined></v-text-field>
              </div>
            </div>
            <div class="mb-6 grid_row">
              <div class="ma-6">
                <div class="ml-1 mt-n3">ผู้สร้างรอบนับ</div>
              </div>
              <div class="mt-3 mr-1">
                {{ $store.state.userDetail.name }}
              </div>
            </div>
            <div class="ma-2 text-right">
              <v-btn class="pa-6 grad-success-bg white--text btn_mobile" @click="save_data()" :disabled="check_btn">แก้ไขข้อมูล</v-btn>
            </div>
          </div>
          <v-overlay :value="overlay" class="z_index">
            <div class="text-center">
              <v-progress-circular
                  indeterminate
                  size="70"
                  width="7"
                  color="#86bc3a"
              ></v-progress-circular>
              <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
            </div>
          </v-overlay>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Count_Edit",
  data() {
    return {
      loading_page: false,
      overlay: false,
      check_btn: false,
      count: null,
      date_show: '',
      item_page: -1,
      emp_lists: [],
      stock_list: [],
    }
  },
  methods: {
    diffDate(date) {
      const value = date.split('-')
      const year = parseInt(value[0])
      return value[2]+'/'+value[1]+'/'+(year + 543);
    },
    async get_edit() {
      this.loading_page = true
      await HTTP.post('/stocks/editstock', {
        stock_id: this.$route.params.id
      }).then((res) => {
        this.loading_page = false
        this.stock_list = res.data.stock
        this.date_show = this.diffDate(this.stock_list.count_date)
        this.emp_lists = res.data.stock_users
      })
    },

    save_data() {
      this.check_btn = true
      this.overlay = true
      HTTP.post('/stocks/editsave', {
        stock_id: this.$route.params.id,
        count: this.stock_list.stock_name,
        date: this.stock_list.count_date,
        note: this.stock_list.stock_note,
        user_create: this.$store.state.userDetail.name,
        emp_lists: this.emp_lists,
      }).then((res) => {
        if (res.data.success === true) {
          this.check_btn = false
          this.overlay = false
          Swal.fire({
            title: 'อัพเดทข้อมูลเรียบร้อย',
            icon: 'success',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then((res) => {
            if (res.isConfirmed === true) {
              this.$router.push('/count_stock/historylist')
            }
            else {
              this.$router.push('/count_stock/historylist')
            }
          })
        }
      })
    }
  },
  mounted() {
    this.get_edit()
  }
}
</script>

<style scoped>
.grid_row {
  display: grid;
  grid-template-columns: 20% 80%;
  grid-gap: 15px 0;
}
.grid_header {
  display: grid;
  grid-template-columns: 20% 80%;
  grid-gap: 15px 0;
}
.grid_checkbox {
  display: grid;
  grid-template-columns: 20% 20% 20% 20%;
  grid-gap: 15px 0;
}
.input_width {
  width: 40%;
}
.d_mobile {
  display: none;
}
.btn_mobile {
  font-size: 20px;
  width: 30%;
}
@media only screen and (max-width: 1000px) {
  .grid_row {
    display: grid;
    grid-template-columns: 30% 70%;
    grid-gap: 15px 0;
  }
  .grid_header {
    display: grid;
    grid-template-columns: 30% 70%;
    grid-gap: 15px 0;
  }
  .grid_checkbox {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .input_width {
    width: 60%;
  }
}
@media only screen and (max-width: 500px) {
  .d_mobile {
    display: grid;
  }
  .btn_mobile {
    font-size: 20px;
    width: 100%;
  }
  .grid_row {
    display: none;
    /*grid-template-columns: 45% 55%;*/
  }
  .grid_header {
    display: none;
    /*grid-template-columns: 45% 55%;*/
  }
  .grid_checkbox {
    display: grid;
    grid-template-columns: 100%;
  }
  .input_width {
    width: 100%;
  }
}
</style>
